import API from 'api/hallomart';

/**
 * Constants
 */

export const FETCH_PRODUCTS = 'soldProducts/FETCH_PRODUCTS';
export const FETCH_PRODUCTS_OK = 'soldProducts/FETCH_PRODUCTS_OK';
export const FETCH_PRODUCTS_FAILED = 'soldProducts/FETCH_PRODUCTS_FAILED';


/**
 * Action Creators
 */

export function fetchSoldProducts(page = 1) {
	return async (dispatch) => {
		try {
			dispatch({ type: FETCH_PRODUCTS });
			const products = await API.getMerchantSoldProducts(page);
			dispatch({
				type: FETCH_PRODUCTS_OK,
				products: products.data,
				totalPages: parseInt(products.headers['x-wp-totalpages'], 10)
			});
		} catch (err) {
			dispatch({ type: FETCH_PRODUCTS_FAILED, error: err.response || err.message });
		}
	};
}


/**
 * Reducers
 */

const initialState = {
	isLoading: false,
	error: false,
	errors: {},
	products: [],
	isLoaded: false,
	totalPages: 1
};

export default function products(state = initialState, action) {
	switch (action.type) {
		case FETCH_PRODUCTS:
			return {
				...state,
				error: false,
				errors: {},
				isLoading: true
			};

		case FETCH_PRODUCTS_OK:
			return {
				...state,
				isLoading: false,
				isLoaded: true,
				products: action.products,
				totalPages: action.totalPages
			};

		case FETCH_PRODUCTS_FAILED:
			return {
				...state,
				isLoading: false,
				error: true,
				errors: action.error
			};

		default:
			return state;
	}
}



// WEBPACK FOOTER //
// ./src/modules/soldProducts.js